/*
 * @Descripttion: 
 * @version: 
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-07-15 14:10:47
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-21 16:52:00
 */
import { createAsyncThunk } from "@reduxjs/toolkit";
import _ from "lodash";
import { sendAsync } from "../../../app/applicationSlice";
import { RootThunkApi } from "../../../app/store";
import { TAHLocationListParams, getTAHLocationList, getTAHLocationDetail, getTAHLocationSubmit, SubmitParams, getRemove, DetailParams } from "../../../services/TAHLocation";

// 列表
export const getTAHLocationListAsync = createAsyncThunk<
  void,
  TAHLocationListParams,
  RootThunkApi<void>
>('TAHLocation/getTAHLocationListAsync', async (params, api) => {
  return sendAsync(getTAHLocationList(params), api)
})


// 详情
export const getTAHLocationDetailAsync = createAsyncThunk<void, DetailParams, RootThunkApi<void>>(
  'TAHLocation/getTAHLocationDetailAsync',
  async (params, api) => {
    return sendAsync(getTAHLocationDetail(params), api)
  }
)


// 保存编辑
export const getTAHLocationSubmitAsync = createAsyncThunk<
  void,
  SubmitParams,
  RootThunkApi<void>
>(
  'TAHLocation/getTAHLocationSubmitAsync',
  async (params, api) => {
    return sendAsync(getTAHLocationSubmit(params), api)
  }
)


// 删除
export const getRemoveAsync = createAsyncThunk<void, any, RootThunkApi<void>>(
  'TAHLocation/getRemoveAsync',
  async (params, api) => {
    return sendAsync(getRemove(params), api)
  }
)
